var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-b-form-input',_vm._g({ref:"searchInput",staticClass:"pr-4",attrs:{"id":"essay-search","size":"sm","type":"text","placeholder":"Filter by name"},on:{"input":_vm.changeText},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }